import * as actionTypes from './actionsTypes';

export const setShipmentId = (shipmentId) => {
  
  return {
    type: actionTypes.SETSHIPMENTID,
    data: shipmentId,
  };
};
